var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMessage = function SvgMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.492 20.43c.899 0 3.086-.961 4.367-1.875.133-.094.243-.133.352-.125.094.008.187.008.281.008 5.328 0 8.945-2.993 8.945-6.766 0-3.75-3.757-6.774-8.437-6.774-4.688 0-8.445 3.024-8.445 6.774 0 2.375 1.453 4.46 3.836 5.742.125.07.156.18.093.297-.414.687-1.148 1.508-1.43 1.875-.304.383-.132.844.438.844Z"
  })));
};
export default SvgMessage;